import { Box, Button, Typography } from '@mui/material'
import React from 'react'

import { Container, Content } from './common'

type Props = {
  onLogout: () => void
}

const LoggedIn: React.FC<Props> = ({ onLogout }) => (
  <Container>
    <Content>
      <Typography className="invitation-message-text" variant="h5" textAlign="center">
        You are logged in with a different account than the invited account.
        <br /> Please log out first and then open the invite link again.
      </Typography>
      <Box pt={2} textAlign="center">
        <Button variant="contained" color="primary" onClick={onLogout}>
          Logout
        </Button>
      </Box>
    </Content>
  </Container>
)

export default LoggedIn
